import React from 'react';
import Layout from '../../components/common/pageLayout';
import Form from '../../components/Document/form';
import constant from '../../constant';
import { toast } from 'react-toastify';
import { v3_add_document } from '../../actions/v3/document';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const AddDocument = (props) => {

    const location = useLocation();
    const { data: encodedData } = location.state || {};
    const onSubmit = (model) => {
        v3_add_document(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message);
                props.history.push(constant.Authedcomponent.shipDocument.url, {
                    data: encodedData
                });

            } else {
                toast.error(res.error);
            }
        });
    };

    return (
        <React.Fragment>
            <Layout title={`Add Document | ${JSON.parse(atob(encodedData))['PROJECT_NAME']}`}>
                <Form
                    projectId={JSON.parse(atob(encodedData))['PROJECT_ID']}
                    title="Add Document"
                    encodedData={encodedData}
                    onSubmit={onSubmit}
                    buttonName="Create Document"
                />
            </Layout>
        </React.Fragment>
    );
};

export default AddDocument;
